import React from "react";
import Banner from "../components/Banner";
import Advisors from "../components/introduction/Advisors";

const AdvisorsPage = () => {
  return (
    <>
      <Banner title="World-Class Academic Standards & Advisors" />
      <Advisors />
    </>
  );
};

export default AdvisorsPage;
